import classNames from 'classnames';
import { ReactNode } from 'react';

type SectionProps = {
  children: ReactNode;
  className?: string;
};

export const Section = ({ children, className }: SectionProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col items-start rounded-md border border-outline-variant bg-white p-4',
        className
      )}
    >
      {children}
    </div>
  );
};
